// JOBE-0166.2: MetricSection — section wrapper for grouped metric rows.
// Renders a small-caps section header followed by MetricRow components.
// Section order is enforced by SuiteCard (SECTION_ORDER constant).

import { MetricRow } from './MetricRow.jsx';
import './MetricSection.css';

/**
 * @param {object} props
 * @param {'write_quality'|'retrieval'|'hygiene'|'performance'} props.section
 * @param {string} props.label
 * @param {import('./mock-suites.js').Metric[]} props.metrics
 */
export function MetricSection({ section, label, metrics }) {
  return (
    <div className="metric-section" data-section={section}>
      <div className="metric-section-header">{label}</div>
      {metrics.map((m) => (
        <MetricRow key={m.id} metric={m} />
      ))}
    </div>
  );
}
